import React, { useEffect, useState } from "react";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLanguage } from "@/context/LanguageContext";
import { BRAND } from "@/lib/config";
import { ExternalLink } from "lucide-react";

const BLOG_URL = "https://www.solteseufrances.com.br";

const Header = () => {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navItems = [
    { id: "teacher", label: t.nav.teacher, aria: "Professor de francês nativo de Paris" },
    { id: "aulas-de-frances", label: t.nav.courses, aria: "Aulas de francês online" },
    { id: "niveis", label: t.nav.levels, aria: "Aulas de francês por nível A1 ao C2" },
    { id: "depoimentos-de-alunos", label: t.nav.testimonials, aria: "Depoimentos de alunos" },
    { id: "contato-leadgen", label: t.nav.contact, aria: "Contato — aulas de francês grátis" },
  ];

  return (
    <header
      data-testid="site-header"
      className={`fixed top-11 sm:top-12 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#f4f1ea]/85 backdrop-blur-xl border-b border-[#e5e3db]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12 flex items-center justify-between h-16 sm:h-20">
        <a
          href="#top"
          data-testid="brand-logo"
          className="flex items-center gap-3 group"
          aria-label="Na Ponta Da Língua · aulas de francês online"
        >
          <span className="font-display text-base sm:text-lg tracking-tight text-[#1e2a5a]">
            {BRAND.name}
          </span>
          <span className="sr-only">{t.brandSubtitle}</span>
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="Navegação principal — aulas de francês">
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`nav-${item.id}`}
              aria-label={item.aria}
              title={item.aria}
              className="text-sm text-[#1e2a5a] link-underline"
            >
              {item.label}
            </a>
          ))}
          <a
            href={BLOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-blog-external"
            aria-label="Solte seu francês — blog gratuito"
            title="Solte seu francês — blog gratuito"
            className="group inline-flex items-center gap-1.5 rounded-full border border-[#d9381e] bg-[#d9381e]/5 px-3.5 py-1.5 text-sm font-medium text-[#d9381e] transition-colors hover:bg-[#d9381e] hover:text-[#f4f1ea]"
          >
            <span className="italic">Solte seu francês</span>
            <ExternalLink className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <LanguageSwitcher />
          {/* Mobile-visible blog badge (nav is hidden on mobile) */}
          <a
            href={BLOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-blog-external-mobile"
            aria-label="Solte seu francês — blog"
            className="md:hidden inline-flex items-center gap-1 rounded-full border border-[#d9381e] px-2.5 py-1 text-[11px] font-medium text-[#d9381e]"
          >
            <span className="italic">Blog</span>
            <ExternalLink className="h-3 w-3" />
          </a>
          <a
            href="#contact"
            data-testid="header-cta"
            className="hidden sm:inline-flex items-center rounded-full bg-[#1e2a5a] px-4 py-2 text-xs sm:text-sm font-medium text-[#f4f1ea] transition-colors hover:bg-[#d9381e]"
          >
            {t.nav.cta}
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
